import React from "react";
import PostGallery from "./PostGallery";
import SubscribeForm from "./SubscribeForm";


export default function Home() {
    return(
        <main>
            <div className="hero">
                <section>
                    <h1 className="hero-text">KMS Blog</h1>
                    <h2>a creative thought laboratory</h2>
                </section>
            </div>
            <div >
                <PostGallery />
            </div>
            <div>
                <SubscribeForm />
            </div>
            
        </main>
    )
}